// 获取设备指纹信息并返回base64编码
export function getDeviceFingerprint() {
  const info = {
    // 优先使用 userAgentData.platform，其次 userAgent，再次 navigator.platform（已弃用）
    platform: navigator.userAgentData?.platform || navigator.userAgent || '',
    screenResolution: `${window.screen.width}x${window.screen.height}`,
    devicePixelRatio: window.devicePixelRatio || 1,
    language: navigator.language || '',
    timezoneOffset: new Date().getTimezoneOffset(),
    cpuCores: navigator.hardwareConcurrency || null,
    deviceMemory: navigator.deviceMemory || null,
    architecture: navigator.userAgentData?.architecture || '',
    colorDepth: window.screen.colorDepth || null,
  };
  const jsonStr = JSON.stringify(info);
  console.log("Device fingerprint info:", jsonStr);
  return btoa(encodeURIComponent(jsonStr));
}
